var SCM = SCM || {};
SCM.DebugLogger = (function () {

    function DebugLogger(namespace, options) {
        this._namespace = namespace || 'SCM';
        this._options = _mergeOptions(options);
        this._timers = {};
    }

    DebugLogger.prototype.debug = function(message, context) {
        _log('debug', this._namespace, message, context, this._options);
    };

    DebugLogger.prototype.info = function(message, context) {
        _log('info', this._namespace, message, context, this._options);
    };

    DebugLogger.prototype.warn = function(message, context) {
        _log('warn', this._namespace, message, context, this._options);
    };

    DebugLogger.prototype.error = function(message, context) {
        _log('error', this._namespace, message, context, this._options);
    };

    DebugLogger.prototype.time = function(label) {
        if (!this._options.debugMode) {
            return;
        }
        const perfNow = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
        this._timers[label] = perfNow;
    };

    DebugLogger.prototype.timeEnd = function(label) {
        if (!this._options.debugMode) {
            return;
        }
        if (this._timers[label] !== undefined) {
            const perfNow = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
            const duration = perfNow - this._timers[label];
            this.info('Timer [' + label + ']: ' + duration.toFixed(2) + 'ms');
            delete this._timers[label];
        }
    };

    function _mergeOptions(options) {
        const defaults = { debugMode: false, level: 'debug' };
        return Object.assign({}, defaults, options);
    }

    function _log(level, namespace, message, context, options) {
        // Always log warnings and errors, regardless of debugMode state
        const alwaysLog = level === 'warn' || level === 'error';
        if (!alwaysLog && (!options.debugMode || !_shouldLog(level, options.level))) {
            return;
        }
        
        let output = '[' + namespace + '] ' + message;
        if (context) {
            output += ' ' + JSON.stringify(context);
        }
        
        console[level](output);
    }

    function _shouldLog(messageLevel, configLevel) {
        const levels = { debug: 0, info: 1, warn: 2, error: 3 };
        return levels[messageLevel] >= levels[configLevel];
    }

    // Factory function for creating instances
    DebugLogger.create = function(namespace, options) {
        return new DebugLogger(namespace, options);
    };

    return DebugLogger;

})();

'object' === typeof module && module.exports && (module.exports = SCM.DebugLogger);